import {ClrDatagridComparatorInterface} from '@clr/angular';
import {User} from '../../../shared/model/User';

export class RoleComparator implements ClrDatagridComparatorInterface<User> {
  compare(a: User, b: User) {
    return a.roles[0].localeCompare(b.roles[0]);
  }
}
